import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const Header: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [accessEmail, setAccessEmail] = useState<string>('');

  useEffect(() => {
    try {
      setAccessEmail(localStorage.getItem('accessEmail') || '');
    } catch {
      setAccessEmail('');
    }
  }, [location.pathname, location.search]);

  const onLogout = () => {
    try {
      localStorage.removeItem('accessEmail');
      localStorage.removeItem('accessPasswordB64');
      localStorage.removeItem('accessPassword');
    } catch {
      // ignore
    }
    setAccessEmail('');
    navigate('/app-access/login', { replace: true, state: { from: '/' } });
  };

  return (
    <header className='bg-[#F4F6F9] py-[15px] shadow-md w-full'>
      <div className='flex items-center justify-between px-10 mx-auto w-full'>
        <div className='flex justify-start items-center pl-0 shrink-0'>
          <Link to='/'>
            <img
              src='/logo/logo.svg'
              alt='Takagi Seiko Logo'
              className='h-auto w-auto max-h-[60px] object-contain [image-rendering:crisp-edges] cursor-pointer'
            />
          </Link>
        </div>

        {accessEmail && (
          <div className="flex items-center gap-4 shrink-0">
            <div className="text-sm text-gray-700">{accessEmail}</div>
            <button
              type="button"
              onClick={onLogout}
              className="text-sm font-medium text-white bg-[#0077C8] px-4 py-2 rounded hover:opacity-90"
            >
              Logout
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
